import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../hooks/useAuth';
import { Link, useLocation } from 'react-router-dom';
// Icons as JSX components
const Home: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path d='M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z' />
  </svg>
);

const Chat: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path d='M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z' />
    <path d='M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z' />
  </svg>
);

const Study: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path d='M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z' />
  </svg>
);

const Coupons: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path
      fillRule='evenodd'
      d='M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z'
      clipRule='evenodd'
    />
  </svg>
);

const Profile: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path
      fillRule='evenodd'
      d='M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z'
      clipRule='evenodd'
    />
  </svg>
);

const Menu: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path
      fillRule='evenodd'
      d='M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z'
      clipRule='evenodd'
    />
  </svg>
);

const Bell: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path d='M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z' />
  </svg>
);

const Search: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill='currentColor' viewBox='0 0 20 20'>
    <path
      fillRule='evenodd'
      d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
      clipRule='evenodd'
    />
  </svg>
);

interface MobileNavigationProps {
  onMenuToggle?: (isOpen: boolean) => void;
}

interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  badge?: number;
  roles?: string[];
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
  onMenuToggle,
}) => {
  const { user } = useAuth();
  const { isDark } = useTheme();
  const location = useLocation();
  const [showDrawer, setShowDrawer] = useState(false);
  // TODO: جلب عدد الإشعارات الحقيقي من NotificationContext
  const [notifications, setNotifications] = useState(0);

  // Navigation items based on user role
  const getNavigationItems = (): NavItem[] => {
    const baseItems: NavItem[] = [
      {
        id: 'home',
        label: 'الرئيسية',
        path: '/dashboard',
        icon: Home,
      },
      {
        id: 'chat',
        label: 'المحادثات',
        path: '/chat',
        icon: Chat,
        // TODO: جلب عدد الرسائل غير المقروءة من Firebase
      },
    ];

    const roleSpecificItems: NavItem[] = [];

    switch (user?.role) {
      case 'student':
        roleSpecificItems.push(
          {
            id: 'study',
            label: 'دراستي',
            path: '/student/assignments',
            icon: Study,
          },
          {
            id: 'coupons',
            label: 'العروض',
            path: '/coupons',
            icon: Coupons,
          }
        );
        break;
      case 'parent':
        roleSpecificItems.push(
          {
            id: 'children',
            label: 'الأطفال',
            path: '/parent/children',
            icon: Study,
          },
          {
            id: 'coupons',
            label: 'العروض',
            path: '/coupons',
            icon: Coupons,
          }
        );
        break;
      case 'teacher':
        roleSpecificItems.push(
          {
            id: 'classes',
            label: 'الفصول',
            path: '/teacher/classes',
            icon: Study,
          },
          {
            id: 'admin',
            label: 'الإدارة',
            path: '/admin/coupons',
            icon: Coupons,
          }
        );
        break;
      default:
        roleSpecificItems.push({
          id: 'coupons',
          label: 'العروض',
          path: '/coupons',
          icon: Coupons,
        });
    }

    return [
      ...baseItems,
      ...roleSpecificItems,
      {
        id: 'profile',
        label: 'حسابي',
        path: '/profile',
        icon: Profile,
      },
    ];
  };

  const navigationItems = getNavigationItems();

  // Check if current path matches navigation item
  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  // Handle drawer toggle
  const toggleDrawer = () => {
    const newState = !showDrawer;
    setShowDrawer(newState);
    onMenuToggle?.(newState);
  };

  // Close drawer on route change
  useEffect(() => {
    setShowDrawer(false);
    onMenuToggle?.(false);
  }, [location.pathname, onMenuToggle]);

  return (
    <>
      {/* Top App Bar - Mobile */}
      <div className='md:hidden fixed top-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-4 py-3'>
        <div className='flex items-center justify-between'>
          {/* Menu Button & Logo */}
          <div className='flex items-center gap-3'>
            <button
              onClick={toggleDrawer}
              className='p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
              aria-label='فتح القائمة'
            >
              <Menu className='w-5 h-5 text-gray-700 dark:text-gray-300' />
            </button>

            <Link to='/dashboard' className='flex items-center gap-2'>
              <div className='w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center'>
                <span className='text-white font-bold text-sm'>CT</span>
              </div>
              <span className='font-bold text-gray-900 dark:text-white text-lg'>
                كلاس تك
              </span>
            </Link>
          </div>

          {/* Search & Notifications */}
          <div className='flex items-center gap-2'>
            <button
              className='p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
              aria-label='البحث'
            >
              <Search className='w-5 h-5 text-gray-700 dark:text-gray-300' />
            </button>

            <Link
              to='/notifications'
              className='relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
              aria-label={`الإشعارات ${
                notifications > 0 ? `(${notifications})` : ''
              }`}
            >
              <Bell className='w-5 h-5 text-gray-700 dark:text-gray-300' />
              {notifications > 0 && (
                <span className='absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium'>
                  {notifications > 9 ? '9+' : notifications}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Tab Bar - Mobile */}
      <div className='md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 px-2 py-1 safe-area-inset-bottom'>
        <div className='flex items-center justify-around'>
          {navigationItems.slice(0, 5).map(item => {
            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <Link
                key={item.id}
                to={item.path}
                className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 min-w-0 flex-1 ${
                  active
                    ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                }`}
                aria-label={item.label}
              >
                <div className='relative'>
                  <Icon
                    className={`w-5 h-5 transition-transform duration-300 ${
                      active ? 'scale-110' : 'hover:scale-105'
                    }`}
                  />

                  {item.badge && item.badge > 0 && (
                    <span className='absolute -top-2 -right-2 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium'>
                      {item.badge > 9 ? '9+' : item.badge}
                    </span>
                  )}
                </div>

                <span
                  className={`text-xs font-medium truncate transition-all duration-300 ${
                    active ? 'text-blue-600 dark:text-blue-400' : ''
                  }`}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Slide-out Drawer - Mobile */}
      {showDrawer && (
        <>
          {/* Backdrop */}
          <div
            className='md:hidden fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity duration-300'
            onClick={toggleDrawer}
          />

          {/* Drawer Content */}
          <div
            className={`md:hidden fixed top-0 right-0 h-full w-80 max-w-[85vw] z-50 bg-white dark:bg-gray-900 shadow-xl transform transition-transform duration-300 ${
              showDrawer ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            {/* Drawer Header */}
            <div className='p-4 border-b border-gray-200 dark:border-gray-800'>
              <div className='flex items-center justify-between'>
                <div className='flex items-center gap-3'>
                  <div className='w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center'>
                    <span className='text-white font-bold'>
                      {user?.name?.charAt(0) || 'U'}
                    </span>
                  </div>
                  <div>
                    <h3 className='font-semibold text-gray-900 dark:text-white'>
                      {user?.name || 'مستخدم'}
                    </h3>
                    <p className='text-sm text-gray-600 dark:text-gray-400'>
                      {user?.role === 'student'
                        ? 'طالب'
                        : user?.role === 'parent'
                        ? 'ولي أمر'
                        : user?.role === 'teacher'
                        ? 'معلم'
                        : 'مستخدم'}
                    </p>
                  </div>
                </div>

                <button
                  onClick={toggleDrawer}
                  className='p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
                  aria-label='إغلاق القائمة'
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Drawer Navigation */}
            <div className='flex-1 overflow-y-auto py-4'>
              <nav className='space-y-1 px-4'>
                {navigationItems.map(item => {
                  const Icon = item.icon;
                  const active = isActive(item.path);

                  return (
                    <Link
                      key={item.id}
                      to={item.path}
                      onClick={toggleDrawer}
                      className={`flex items-center gap-3 p-3 rounded-xl transition-all duration-300 ${
                        active
                          ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 border border-blue-200 dark:border-blue-800'
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                      }`}
                    >
                      <div className='relative'>
                        <Icon
                          className={`w-5 h-5 transition-transform duration-300 ${
                            active ? 'scale-110' : ''
                          }`}
                        />

                        {item.badge && item.badge > 0 && (
                          <span className='absolute -top-2 -right-2 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium'>
                            {item.badge > 9 ? '9+' : item.badge}
                          </span>
                        )}
                      </div>

                      <span className='font-medium'>{item.label}</span>
                    </Link>
                  );
                })}
              </nav>

              {/* Additional Links */}
              <div className='mt-6 px-4 space-y-1'>
                <div className='px-3 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide'>
                  المزيد
                </div>

                <Link
                  to='/referral'
                  onClick={toggleDrawer}
                  className='flex items-center gap-3 p-3 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
                >
                  <div className='w-5 h-5 bg-gradient-to-r from-yellow-500 to-orange-500 rounded flex items-center justify-center'>
                    <span className='text-white text-xs font-bold'>R</span>
                  </div>
                  <span className='font-medium'>برنامج الإحالة</span>
                </Link>

                <Link
                  to='/settings'
                  onClick={toggleDrawer}
                  className='flex items-center gap-3 p-3 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
                >
                  <div className='w-5 h-5 bg-gradient-to-r from-gray-500 to-gray-600 rounded flex items-center justify-center'>
                    <span className='text-white text-xs font-bold'>⚙</span>
                  </div>
                  <span className='font-medium'>الإعدادات</span>
                </Link>
              </div>
            </div>

            {/* Drawer Footer */}
            <div className='p-4 border-t border-gray-200 dark:border-gray-800'>
              <div className='text-center text-xs text-gray-500 dark:text-gray-400'>
                Class-Tech © 2024
              </div>
            </div>
          </div>
        </>
      )}

      {/* Spacer for fixed elements */}
      <div className='md:hidden'>
        <div className='h-16' /> {/* Top app bar spacer */}
        <div className='h-20' /> {/* Bottom tab bar spacer */}
      </div>
    </>
  );
};

export default MobileNavigation;
